
const transactPW = "789n5f587482";

const chorPW = "chorLOL1337";

export {chorPW, transactPW};